<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="isEditMode ? 'Edit Upsell' : 'Add Upsell'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>
      <ng-container>
        <tidy-card>
          <tidy-row>
            <tidy-select
              [label]="'Property'"
              [items]="addressFilter"
              [multiple]="false"
              [form]="form.get('property')"
              [icon]="'assets/svg/home.svg'"
              [errorMessage]="'Please select a property.'"
              [submitted]="submitted"
              (optionChange)="onPropertyChange($event)"
              formControlName="property" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              formControlName="reservation"
              [form]="form.get('reservation')"
              [items]="reservationItems"
              [label]="'Reservation'"
              [errorMessage]="'Please enter your reservation.'"
              [disableElement]="!form.get('property').value"
              [submitted]="submitted"
              [matTooltip]="!form.get('property').value ? ('Please select a property first.' | translate) : ''"
              [icon]="'assets/svg/today.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              formControlName="requestType"
              [form]="form.get('requestType')"
              [items]="requestTypeItems"
              [label]="'Request Type'"
              [errorMessage]="'Please enter your request type.'"
              [submitted]="submitted"
              [icon]="'assets/svg/bookmark.svg'" />
          </tidy-row>
        </tidy-card>

        <tidy-button
          [text]="isEditMode ? 'Update Upsell' : 'Add Upsell'"
          [action]="boundAddUpsell"
          class="primary" />

        @if (isEditMode) {
          <tidy-row class="extra-padding-top" [align]="'center'" style="padding-top: 1rem;">
            <tidy-text class="link" (action)="markAsDone()" [body]="'Mark as done'" />
          </tidy-row>
        }

        <tidy-error-message [text]="errorMessage" />
      </ng-container>
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
